import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceSliceDTO } from './types'

export const DATA_SAMPLING_FRAGMENT: TypedDocumentNode<WorkspaceSliceDTO> = gql`
  fragment dataSamplingFragment on Workspace {
    id
    prebidManagerSampling
  }
`
